import React from "react";
import { formatPhoneInput } from "../../FormCard";
import { inCls, Field } from "./shared";

export default function ContactStep({ data, onChange, firstFieldRef }) {
  const set = (k) => (e) => onChange({ ...data, [k]: e.target.value });
  return (
    <>
      <Field id="onb-contact-name" label="Nom complet" required>
        <input id="onb-contact-name" ref={firstFieldRef} type="text" value={data.name || ""} onChange={set("name")} className={inCls} />
      </Field>
      <Field id="onb-contact-function" label="Fonction">
        <input id="onb-contact-function" type="text" value={data.function || ""} onChange={set("function")} className={inCls} placeholder="Ex. Directeur, Responsable communication..." />
      </Field>
      <Field id="onb-contact-email" label="Adresse e-mail" required>
        <input id="onb-contact-email" type="email" value={data.email || ""} onChange={set("email")} className={inCls} />
      </Field>
      <div className="grid grid-cols-2 gap-3">
        <Field id="onb-contact-phone" label="Téléphone">
          <input id="onb-contact-phone" type="tel" inputMode="tel" value={data.phone || ""}
            onChange={(e) => onChange({ ...data, phone: formatPhoneInput(e.target.value) })} className={inCls} />
        </Field>
        <Field id="onb-contact-mobile" label="Mobile">
          <input id="onb-contact-mobile" type="tel" inputMode="tel" value={data.mobile || ""}
            onChange={(e) => onChange({ ...data, mobile: formatPhoneInput(e.target.value) })} className={inCls} />
        </Field>
      </div>
    </>
  );
}
